<template>
    <div>
        <v-toolbar flat class="primary--text">
            Sitios asignados
            <v-spacer></v-spacer>
            <v-btn icon color="accent" @click="modal_plants = true">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-toolbar>
        <v-list-item
            v-for="plant in list_plants"
            :key="plant.id"
        >
            <v-list-item-content>
                {{plant.name}}
            </v-list-item-content>

            <v-list-item-avatar>
                <v-btn icon @click="removePlant(plant.id)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </v-list-item-avatar>
        </v-list-item>
        <v-dialog v-model="modal_plants" scrollable max-width="80%">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="modal_plants = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-list >
                        <v-list-item
                            v-for="plant in plants"
                            :key="plant.id"
                            @click="togglePlant(plant.id)"
                        >
                            <v-list-item-title>{{ plant.name }}</v-list-item-title>
                            <v-list-item-action>
                                <v-icon v-if="user_plants.includes(plant.id)" color="accent">mdi-check</v-icon>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'list_plant',
    props: ['user'],
    computed: {
        ...mapState({ plants: state => state.gateways.list }),
        list_plants(){
            if(this.plants && this.user_plants){
                return this.plants.filter( p => this.user_plants.includes(p.id))
            }
        }
    },
    data() {
        return {
            user_plants: [],
            modal_plants: false
        }
    },
    methods: {
        ...mapActions({ 
            getPlants: 'account/getPlantsUsers',
            savePlants: 'account/editUserPlants'
        }),
        async loadPlants(){
            if(this.user)
                this.user_plants = await this.getPlants(this.user)
        },
        removePlant(plant){
            const index = this.user_plants.findIndex( p => p == plant )
            this.user_plants.splice(index, 1)
        },
        togglePlant(plant){
            if(this.user_plants.find( p => plant == p ))
                this.removePlant(plant)
            else
                this.user_plants.push(plant)
        },
        async save(user){
            try {
                await this.savePlants({
                    plants: this.user_plants,
                    user
                })
            } catch (error) {
                console.log(error)
            }
        }
    },
    watch: {
        user(){
            this.loadPlants()
        }
    },
    mounted(){
        this.loadPlants()
    }
}
</script>